/**
 * @description 將數字依據小數位數長度設定轉換為指定小數位數長度之數字(四捨五入)
 * @param value 要轉換的值
 * @param decimalLength 小數位長度，預設為 0
 * @returns 轉換後的值
 */
export function doRoundByDecimalLength(
  value: number,
  decimalLength = 0
): number {
  const step = 10;
  let calucateValue = 1;
  for (let index = 0; index < decimalLength; index++) {
    calucateValue = calucateValue * step;
  }

  return Math.round(value * calucateValue) / calucateValue;
}
